import axios from 'axios'

export default {
  getInitialData (callback, errorCallback) {
    axios
      .get('/api/dashboard.json')
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  }
}
